import { useState, useEffect } from "react";
import { system_table } from "../../service/system";
import { getPageSetting } from "../../service/common";
import moment from "moment";

const useSearchFilter = ({
  defaultFilter = {},
  searchKey = [],
  tbSetting = null,
  reloadAction = null,
} = {}) => {
  const [filterData, setFilterData] = useState(defaultFilter);
  const [searchData, setSearchData] = useState(defaultFilter);

  const changeFilter = ({ name, value, options }) => {
    const {
      dateEffectKey,
      dateDirection,
      dateEffectNumber = 1,
      dateEffectUnit,
    } = options;
    let tempFilter = { ...filterData };

    /* 
      區間日期起迄(動態)
      dateEffectKey: 欄位 name
      dateDirection: 起訖 start/end
      dateEffectNumber: 區間範圍 值
      dateEffectUnit: 區間範圍 單位 days/months/years
    */
    if (dateEffectKey) {
      let compareDate = tempFilter[dateEffectKey];
      if (
        dateDirection === "start" &&
        compareDate &&
        (new Date(compareDate) < new Date(value) ||
          (dateEffectNumber &&
            moment(compareDate).subtract(dateEffectNumber, dateEffectUnit) >
              new Date(value)))
      ) {
        tempFilter[dateEffectKey] = moment(value)
          .add(dateEffectNumber, dateEffectUnit)
          .format("YYYY-MM-DD");
      } else if (
        dateDirection === "end" &&
        compareDate &&
        (new Date(compareDate) > new Date(value) ||
          (dateEffectNumber &&
            moment(compareDate).add(dateEffectNumber, dateEffectUnit) <
              new Date(value)))
      ) {
        tempFilter[dateEffectKey] = moment(value)
          .subtract(dateEffectNumber, dateEffectUnit)
          .format("YYYY-MM-DD");
      }
    }

    setFilterData({
      ...tempFilter,
      [name]: value,
    });
  };

  // 取 該頁搜尋參數
  useEffect(() => {
    let result = getPageSetting(searchKey);

    let temp = { ...defaultFilter, ...filterData };
    if (result)
      temp = {
        ...temp,
        ...result.params,
      };

    setFilterData(temp);
    setSearchData(temp);
  }, []);

  // 判斷是否搜尋
  useEffect(() => {
    if (!searchData) return;

    if (tbSetting) {
      let size = searchData.size ?? system_table.size;
      tbSetting.setTbFirstIndex(((searchData.page ?? 1) - 1) * size);
      tbSetting.setTbRows(size);
    }

    if (reloadAction) reloadAction();
  }, [searchData]);

  return {
    filterData,
    setFilterData,
    searchData,
    setSearchData,
    changeFilter,
  };
};

export default useSearchFilter;
